import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Real } from '../../core/models/real.model';
import { Observable, zip, of} from 'rxjs';
import { map, tap, take, filter } from 'rxjs/operators';
import { ToastController } from '@ionic/angular';

import { Attendee } from "../../core/models/cart/attendee.model";
import { Cart } from "../../core/models/cart/cart.model";
import { Pick } from "../../core/models/cart/pick.model";
import { CartService } from "../../core/services/cart.service";
import { DepsService } from "../../core/services/deps.service";
import { ProviderServiceService } from '../../core/services/provider-service.service';
import { ShopDetailService } from '../../core/services/shop-detail.service';
import { SearchPreferencesService } from '../../core/services/search-preferences.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-pick-services',
  templateUrl: './pick-services.component.html',
  styleUrls: ['./pick-services.component.scss'],
})
export class PickServicesComponent implements OnInit {

  @Input() real: Real;
  @Output() pickSlotActive = new EventEmitter<boolean>();

  services$: Observable<any>;

  wineListOpened = false;
  suppliersOpened = false;
  giftCertificates = false;

  servicesSnapshot: {};

  pick: Pick;

  toastRef: any;

  openCategories: number[] = [0];

  constructor( 
    private providerServiceService: ProviderServiceService,
    private cartService: CartService,
    private depsService: DepsService,
    public toastController: ToastController,
    private searchPreferencesService: SearchPreferencesService,
    private translateService: TranslateService
  ) { 

  }

  ngOnInit() {


    const cart = this.cartService.getCart();

    let parentCategoriesPicked: Array<number> = [];

    this.pick = cart.getPickByShopId( parseInt(this.real.id ));

    console.log(this.pick.partySize);
    
    this.pickSlotActive.emit( this.pick.areServicesPickedAndDepsOk() );
    
    if ( this.pick.attendees[0] ) {
      parentCategoriesPicked = this.pick.attendees[0].getCategoriesPicked();
    }
    
    this.services$ = zip(
      this.providerServiceService.getServicesForPicking( this.real.selectionItems[0].id ),
      this.searchPreferencesService.searchPreferences$
    ).pipe(
      tap(
        ( ([categories, searchPreferences]) => {

          if (!categories) {
            return false;
          }

          console.log(categories);
          //categories = categories.filter( (value, index) => value.slug != 'priljubljene-jedi'  );
          
         
          let oneIsOpen = false;

          //open categories with picked services
          categories.map( (value, index) => {



            if ( parentCategoriesPicked.length > 0 && parentCategoriesPicked.indexOf(value.id) !== -1 ) {
              value.menuOpen = true;
              oneIsOpen = true;
            }

            //open searched services
            if ( value.taxonomy && searchPreferences && searchPreferences.normalizedService && searchPreferences.normalizedService.id ) {
              if( value.taxonomy === /*searchPreferences.normalizedService.id*/ searchPreferences.normalizedService.id.substring(0,value.taxonomy.length) && value.taxonomy.length > 6 ) {
                value.menuOpen = true;
                oneIsOpen = true;
              }
            }

          });

          //open first category if no other is opened
          if ( categories[0] && !oneIsOpen ) {
            categories[0].menuOpen = true;  
          }

          if ( categories[1] && !oneIsOpen ) {
            categories[1].menuOpen = true;  
          }

          //services snapshot for deps toast
          let output = {};
          for( let s of categories ) {
            
            output[ s.id.toString() ] = s;


            if ( s.children) {

              for( let t of s.children ) {
                 output[ t.id.toString() ] = t;
              }

            }

          }

          this.servicesSnapshot = output;
        }
        ),
      ),
      map( ([categories, searchPreferences]) => categories ),
      
      map( categories => categories.filter(category => category.slug.substr(0,12) != 'priljubljene') ),
      map( categories => categories.filter(category => category.newService) ),
      
      take(1)
    );

    /*this.services$ = this.providerServiceService.getServicesForPicking( this.real.selectionItems[0].id ).pipe(
      tap(
        (categories) => {

          //open searched categories
          console.log(categories);

          //open first category
          categories[0].menuOpen = true;

          //open categories with picked services
          categories.map( (value, index) => {
            if ( parentCategoriesPicked.length > 0 && parentCategoriesPicked.indexOf(value.id) !== -1 ) {
              value.menuOpen = true;
            }
          });


          //services snapshot for deps toast
          let output = {};
          for( let s of categories ) {
            output[ s.id.toString() ] = s;
          }

          this.servicesSnapshot = output;
        }
      ),
      take(1) //just in case we forget to unsubscribe,
    )*/

  }

  isServicePicked( service, attendeeIndex = 0 ) {
    
    let a = this.pick.getAttendeeByIndex( attendeeIndex );
    
    if ( !a.services || a.services.length === 0 ) {
      return false;
    }

    for( let s of a.services ) {
      if ( s.id === service.id )  {
        return true;
      }
    }

    return false;
    
  }

  areServicesPicked() {
    
    if (!this.pick) {
      return false;
    }

    let a = this.pick.getAttendeeByIndex( 0 );
    if ( !a.services || a.services.length === 0 ) {
      return false;
    }

    return true;
  }

  async presentToast( text ) {
    this.toastRef = await this.toastController.create({
      message: text,
      color: 'primary'
    });
    this.toastRef.present();
  }


  toggleService( service, category, attendeeIndex = 0 ) {

    if ( this.toastRef ) {
      this.toastRef.dismiss();
    }

    const attendee = this.pick.getAttendeeByIndex( attendeeIndex );
    
    if (this.pick.combination) {
      delete this.pick.combination;
    }

    attendee.toggleService( service, category );

    let text = this.depsService.getMissingDeps( attendee, this.real, this.servicesSnapshot );

    if ( text && text.length > 0 ) {
      attendee.setDepsIssue(true);
      this.presentToast(text[0]);

    } else {
      attendee.setDepsIssue(false);
    }

    //output event that services are picked and there are no dependency issues
    this.pickSlotActive.emit( this.pick.areServicesPickedAndDepsOk() );
    
  }

  formatDescription( text ) {
    return text.replace(/\[BR\]/g, "<br/>");
  }

}